import axios from 'axios'

export default {
    fetchVersion() {
        return axios.get('version/version').then(response => {
            return response.data
        })
    },
}
